// extracted by mini-css-extract-plugin
export default {"overlay":"hA-z","bodyOpen":"iA-z","content":"jA-z","header":"kA-z","close":"lA-z","closeNoHeading":"mA-z"};